module.exports = __webpack_public_path__ + "img/objCurve.00880739.svg";